import { render } from "./orderDetailsAnalyticsComponent.vue?vue&type=template&id=3b116fac"
import script from "./orderDetailsAnalyticsComponent.vue?vue&type=script&lang=js"
export * from "./orderDetailsAnalyticsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__